<template>
  <v-container class="mt-4 mb-4">
    <v-row>
      <v-col cols="4">
        <!-- Cancel pipeline dialog -->
        <v-dialog v-model="success" persistent max-width="500px">
          <v-card>
            <v-card-title class="text-h5"
              >Pipeline submitted : JobID {{ jobid }}</v-card-title
            >

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="showPipelines"
                >OK</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-card>
          <v-card-title>{{ this.name }}</v-card-title>
          <v-card-text>
            {{ this.description }}
          </v-card-text>
        </v-card>
        <v-card class="mt-2">
          <v-card-text>
            <div v-html="this.help" />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="8">
        <v-card flat>
          <v-card-text>
            <v-form
              lazy-validation
              v-model="valid"
              id="form"
              ref="form"
              @submit.prevent="submitPipeline"
            >
              <!-- <v-search-box /> -->
              <v-jsf v-model="model" :schema="schema">
                <template slot="custom-dataset" slot-scope="context">
                  <v-search-box v-bind="context" />
                </template>
              </v-jsf>

              <v-row>
                <v-col cols="6">
                  <v-card-title>Resources</v-card-title>
                  <v-card-text>
                    <v-slider
                      label="CPU"
                      step="2"
                      ticks="always"
                      min="2"
                      max="60"
                      thumb-label="always"
                      :thumb-size="24"
                      v-model="resources.cpu"
                    />
                    <v-slider
                      label="Memory (GiB)"
                      step="12"
                      ticks="always"
                      min="12"
                      max="128"
                      thumb-label="always"
                      :thumb-size="24"
                      v-model="resources.memory"
                    />
                    <v-slider
                      label="Workers"
                      step="1"
                      ticks="always"
                      min="1"
                      max="10"
                      thumb-label="always"
                      :thumb-size="24"
                      v-model="resources.workers"
                    />
                  </v-card-text>
                </v-col>
                <v-col cols="6">
                  <v-card-title>Access to Volumes</v-card-title>
                  <v-card-text>
                    <v-select
                      v-model="storage"
                      :items="storage_items"
                      attach
                      chips
                      label="Storage"
                      multiple
                    ></v-select>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn type="submit" form="form" color="primary">
              <v-icon left>mdi-play</v-icon>
              Submit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
  
<script>
import { API, OWL_PIPELINE_ADD, OWL_PIPELINE_DEFINITION } from "@/axios-config";
import VSearchBox from "../components/VSearchBox.vue";

export default {
  name: "PipelineRun",
  components: {
    "v-search-box": VSearchBox,
  },
  data() {
    return {
      name: "Pipeline",
      description: "Description",
      help: "",
      pipelineId: Number(this.$route.params.id),
      valid: false,
      success: false,
      model: {},
      storage_items: [
        "/storage/incoming",
        "/storage/imaxt",
        "/storage/incoming.space.2025",
        "/storage/scratch.space"
      ],
      storage: [],
      pipeline_id: 1,
      jobid: 1,
      schema: {},
      schema_id: {
        pipeline_id: {
          type: "integer",
          default: Number(this.$route.params.id),
          readOnly: true,
          "x-display": "hidden",
        },
      },
      schema_pipeline: {},
      resources: {
        cpu: 4,
        memory: 12,
        workers: 1,
      },
    };
  },
  methods: {
    showPipelines() {
      this.success = false;
      this.$router.push({ name: "Pipelines" });
    },
    async submitPipeline() {
      const isValid = this.$refs.form.validate();
      this.model["pipedef"] = this.pipelineId;
      this.model["version"] = "2.0";
      this.model["name"] = this.name;
      this.model["resources"] = this.resources;
      this.model["resources"]["volumes"] = this.storage;
      if (isValid) {
        try {
          const { data } = await API.post(OWL_PIPELINE_ADD, this.model);
          // this.$refs.form.resetValidation();
          this.success = true;
          this.jobid = data.jobid;
        } catch (error) {
          console.log(error);
        }
      }
    },
  },
  mounted: function () {
    this.$nextTick(async function () {
      // Code that will run only after the
      // entire view has been rendered
      // we can run async functions here

      try {
        const { data } = await API.get(OWL_PIPELINE_DEFINITION, {
          params: {
            id: this.pipelineId,
          },
        });
        this.items = data[0];
        console.log(this.items);
        this.name = this.items.name;
        this.description = this.items.description;
        this.help = this.items.help;
        this.schema = this.items.schema;
        // this.schema.properties = {
        //   ...this.schema.properties,
        //   ...this.schema_default,
        // };
      } catch (error) {
        console.log(error);
      }

      this.$refs.form.resetValidation();
    });
  },
};
</script>

<style>
.vjsf-property .title2 {
  padding-left: 0.25em;
  background-color: red;
}
</style>
